import { GLDetailsHeader, GLDetailsHeaderTitle, GlobalViewDetailsContainer, SelectedPinAction } from './GlobalView.styled'
import { XIcon } from 'assets/icons/XIcon'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { Box, Flex } from 'styling/GlobalStyles'
import { OtherText, TitleText } from 'styling/Typography'
import Avatar from '../../assets/images/profileAvatar.png'
import { useMemo } from 'react'
import { IGlobalViewMachinesReponse } from 'types/api/globalViewApi.interface'
import { NoItems } from 'components/NoItems-fallback/NoItems'

export const GlobalViewMachinesList = ({ list, setList, map }: { list: { open: boolean, type: number }, map, setList: React.Dispatch<React.SetStateAction<{ open: boolean, type: number }>> }) => {
    const { machines } = useSelector((state: RootState) => state.globalView)

    const m = useMemo<IGlobalViewMachinesReponse[]>(() => machines.filter(m => !list.type ? true : m.status == list.type), [machines, list])

    const handleZoom = (position: { latitude: number, longitude: number }) => {
        if (!position) {
            return
        }
        map.setCenter({ lng: position.longitude, lat: position.latitude })
        map.setZoom(20)
    }

    return <GlobalViewDetailsContainer closed={!list.open} >
        <SelectedPinAction style={{ top: '1.3rem' }} onClick={() => setList({ open: false, type: null })} ><XIcon /></SelectedPinAction>
        <GLDetailsHeader  >
            <GLDetailsHeaderTitle>
                <TitleText weight='bold' >Machines</TitleText>
            </GLDetailsHeaderTitle>
        </GLDetailsHeader>
        <Flex height='100%' column gap='1rem' style={{ overflow: 'auto' }} >


            {m?.length ? m.map(m => <Box key={m.id} style={{ padding: 10, cursor: 'pointer' }} onClick={() => handleZoom(m.vehicle)} >
                <Flex width='100%' gap='1rem' center >
                    <img style={{ borderRadius: 50, border: '1px solid white', minWidth: 40, height: 40 }} src={m.imageUrl || Avatar} />
                    <Flex column between width='100%'>
                        <Flex width='100%' between >
                            <TitleText weight='bold' >{m.name}</TitleText>
                            {/* <Flex center gap='5px' >  <RatingIcon /><OtherText>{u.}</OtherText></Flex> */}
                        </Flex>
                        {/* <OtherText weight='bold' >{u.}</OtherText> */}
                        {/* <Flex><OtherText>Status:</OtherText><OtherText weight='bold' >{u.}</OtherText></Flex> */}
                        {/* <OtherText>{m.}</OtherText> */}
                        <Flex><OtherText>{m.userFirstName ? m.userFirstName + ' ' + m.userLastName : ''}</OtherText></Flex>
                        <Flex><OtherText>Status:</OtherText><OtherText weight='bold' >{m.status == 1 ? 'Free' : 'Busy'}</OtherText></Flex>
                        <Flex><OtherText>Task:</OtherText><OtherText weight='bold' >{m.taskName || ' /'}</OtherText></Flex>
                    </Flex>
                </Flex>
            </Box>) : <NoItems title='Machiens' marginTop='5rem' />}
        </Flex>

    </GlobalViewDetailsContainer>
}